import { render, staticRenderFns } from "./cabinet-qualification.vue?vue&type=template&id=5ae6e595&scoped=true&"
import script from "./cabinet-qualification.vue?vue&type=script&lang=js&"
export * from "./cabinet-qualification.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-qualification.vue?vue&type=style&index=0&id=5ae6e595&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae6e595",
  null
  
)

export default component.exports